import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AppNavbar from "../components/common/AppNavbar";

function RamNavamiWishesPage() {
  return (
    <>
      <AppNavbar />
      <div className="container my-5">
        {/* Header */}
        <div className="mb-4">
          <h2 className="fw-bold">
            Bharat Abroad Celebrates the Birth of Lord Rama – Happy Ram Navami
            2026
          </h2>
          <p className="text-muted">April 2026 — Global Celebration</p>
        </div>

        {/* Video Section */}
        <div className="mb-5">
          <div className="ratio ratio-16x9">
            <iframe
              src="https://www.youtube.com/embed/zu0u58tk5oc"
              title="Ram Navami Celebration"
              allowFullScreen
            ></iframe>
          </div>
        </div>

        {/* Main Content */}
        <div className="mb-4">
          <p>
            Ram Navami marks the divine birth of Lord Rama, the embodiment of
            righteousness, virtue, and dharma. Celebrated with deep devotion
            across Bharat and by global communities, this sacred festival
            inspires values of truth, compassion, and courage.
          </p>

          <p>
            Bharat Abroad extends heartfelt Ram Navami wishes to devotees around
            the world. May the blessings of Lord Rama bring peace, strength, and
            prosperity into your lives.
          </p>
        </div>

        {/* Significance Section */}
        <div className="mb-4">
          <h3 className="fw-bold">The Significance of Ram Navami</h3>
          <p>
            Ram Navami commemorates the birth of Lord Rama in Ayodhya, as
            described in the sacred epic Ramayana. His life represents the ideal
            path of duty, honor, and devotion.
          </p>

          <p>
            Devotees observe fasts, visit temples, chant prayers, and read
            scriptures to seek divine blessings and spiritual growth on this
            auspicious day.
          </p>
        </div>

        {/* Celebration Section */}
        <div className="mb-4">
          <h3 className="fw-bold">Ram Navami Across the Globe</h3>
          <p>
            From grand temple celebrations in Bharat to devotional gatherings
            across countries like Nepal, USA, UK, Australia, and Singapore, Ram
            Navami is celebrated with immense faith and enthusiasm.
          </p>

          <p>
            Cultural programs, bhajans, and community prayers unite people,
            spreading the timeless message of Lord Rama beyond borders.
          </p>
        </div>

        {/* Wishes Card */}
        <div className="card mb-4 shadow-sm text-center">
          <div className="card-body">
            <h3 className="fw-bold text-warning">Happy Ram Navami!</h3>
            <p className="mt-3">May Lord Rama bless you with:</p>
            <ul className="list-unstyled">
              <li>🕉️ Strength and Courage</li>
              <li>🌸 Peace and Harmony</li>
              <li>🙏 Devotion and Wisdom</li>
              <li>✨ Happiness and Prosperity</li>
            </ul>
            <p className="fw-semibold mt-3">
              Wishing you and your family a blessed and joyful Ram Navami!
            </p>
          </div>
        </div>

        {/* Closing */}
        <div className="mb-5">
          <h3 className="fw-bold">Celebrating Dharma, Celebrating Divinity</h3>
          <p>
            At Bharat Abroad, we honor and promote Bharat’s spiritual heritage
            worldwide. Ram Navami is a reminder of the eternal values that guide
            humanity towards truth and righteousness.
          </p>

          <p className="fw-semibold">
            Jai Shri Ram! May His blessings always guide you.
          </p>
        </div>
      </div>
    </>
  );
}

export default RamNavamiWishesPage;
